import { Realtime } from 'ably/build/ably-commonjs/'

export default new Realtime(process.env.REACT_APP_ABLY_API_KEY)
